var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92383 14.6876C1.69541 14.6871 1.47104 14.6243 1.27279 14.5051C0.826358 14.2395 0.548828 13.7239 0.548828 13.1641V1.83601C0.548828 1.27468 0.826358 0.760616 1.27279 0.494991C1.47576 0.372505 1.70635 0.309516 1.94044 0.312609C2.17453 0.315701 2.40354 0.38476 2.60352 0.512569L11.8241 6.30788C12.0163 6.4344 12.1747 6.61009 12.2845 6.81848C12.3943 7.02687 12.4519 7.26113 12.4519 7.49929C12.4519 7.73745 12.3943 7.9717 12.2845 8.18009C12.1747 8.38848 12.0163 8.56417 11.8241 8.69069L2.60203 14.4876C2.39738 14.6175 2.16297 14.6866 1.92383 14.6876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.a17667a3fc9c20cbb271dfc6f74b22ac.svg";
export { ForwardRef as ReactComponent };